import { mergeMap, tap } from 'rxjs/operators';
// RxJS
import { delay, distinctUntilChanged, skip, filter, take, map } from 'rxjs/operators';
// NGRX
import { Store, select } from '@ngrx/store';
// CRUD
import { BaseDataSource, QueryResultsModel } from '../../../_base/crud';
// State
import { AppState } from '../../../reducers';
import { selectTransporterInStore, selectTransporterPageLoading, selectTransporterShowInitWaitingMessage } from '../_selectors/transporter.selectors';

export class TransporterDataSource extends BaseDataSource {
	constructor(private store: Store<AppState>) {
		super();

		this.loading$ = this.store.pipe(
			select(selectTransporterPageLoading),
		);

		this.isPreloadTextViewed$ = this.store.pipe(
			select(selectTransporterShowInitWaitingMessage)
		);

		this.store.pipe(
			select(selectTransporterInStore),
		).subscribe((response: QueryResultsModel) => {
			this.paginatorTotalSubject.next(response.totalCount);
			this.entitySubject.next(response.items);
		});
	}
}
